import Vec2 from 'vec2';

import { createSelector } from '@reduxjs/toolkit';

import { FabricState } from './fabric.types';

import { RootState } from '~/redux/store';

export const selectActiveFreeDrawing = createSelector(
  [({ fabric }: RootState) => fabric.activeFreeDrawing],
  (list): Vec2[] => list.map((coords) => new Vec2(coords))
);

export const selectFabricCanvas = ({
  fabric,
}: RootState): FabricState['canvas'] => fabric.canvas;

export const selectFreeDrawMode = ({
  fabric,
}: RootState): FabricState['freeDrawMode'] => fabric.freeDrawMode;

export const selectSelectionCircles = ({
  fabric,
}: RootState): FabricState['selectionCircles'] => fabric.selectionCircles;
